<!-- Basic picker -->

<vui-datepicker [form]="form" controlName="date" [label]="'Data'" placeholder="DD/MM/YYYY"></vui-datepicker>

<!-- Basic picker -->

<vui-range-picker [form]="form" controlName="range" [label]="'Período'" placeholder="DD/MM/YYYY"></vui-range-picker>
